(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_subscription"] && !Shopify.designMode) return;
  try {
    class BuddyLabSubscriptionCard extends HTMLElement {
    constructor() {
      super();
      this.base = parseInt(this.dataset.base, 10) || 0;
      this.maxQty = parseInt(this.dataset.maxQty, 10) || 9;
      this.qty = 1;
    }

    connectedCallback() {
      this.quantityInput = this.querySelector('[data-quantity-input]');
      this.qtyDisplay = this.querySelector('[data-qty-display]');
      this.tiers = Array.from(this.querySelectorAll('[data-tier]'));

      // Alinha a quantidade inicial ao tier que o servidor marcou como ativo,
      // evitando que nenhum tier fique selecionado quando nenhum vale 1.
      if (this.tiers.length && !this.tierForQty(1)) {
        this.qty = parseInt(this.tiers[0].dataset.tierQty, 10) || 1;
      }

      this.tiers.forEach((btn) =>
        btn.addEventListener('click', () => this.setQty(parseInt(btn.dataset.tierQty, 10)))
      );
      this.querySelectorAll('[data-qty-step]').forEach((btn) =>
        btn.addEventListener('click', () => this.setQty(this.qty + parseInt(btn.dataset.qtyStep, 10)))
      );

      // O submit e tratado pelo handler [data-add-to-cart] do global.js do tema.
      this.render();

      /* Segue o seletor de variantes da secao (main-product.liquid), que tem
         form proprio: sem isto, escolher um sabor na PDP nao mudava o que este
         card adiciona nem o preco base dos tiers. */
      this.variantInput = this.querySelector('[data-variant-input]');
      this.ctaAvailable = this.querySelector('[data-cta-available]');
      this.ctaSoldOut = this.querySelector('[data-cta-soldout]');
      this.onVariant = (e) => {
        const d = e.detail || {};
        if (!d.id) return;
        if (this.variantInput) this.variantInput.value = d.id;
        if (typeof d.price_amount === 'number') {
          this.base = d.price_amount;
          this.render();
        }
        if (typeof d.available === 'boolean') {
          const cta = this.querySelector('[data-cta]');
          if (cta) cta.disabled = !d.available;
          if (this.ctaAvailable) this.ctaAvailable.hidden = !d.available;
          if (this.ctaSoldOut) this.ctaSoldOut.hidden = d.available;
        }
      };
      document.addEventListener('buddylab:pdp:variant', this.onVariant);
    }

    disconnectedCallback() {
      if (this.onVariant) document.removeEventListener('buddylab:pdp:variant', this.onVariant);
    }

    money(cents) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }

    /* Tier exato: usado para marcar qual cartao esta selecionado. */
    tierForQty(q) {
      return this.tiers.find((t) => parseInt(t.dataset.tierQty, 10) === q) || null;
    }

    /* Desconto que vale para a quantidade: o do maior tier que ela alcanca.
       Desconto automatico por quantidade no Shopify e "a partir de N", entao 4
       unidades continuam no desconto do tier de 3. Casar so o tier exato fazia
       o CTA anunciar R$ 279,60 em 4 potes enquanto o checkout cobrava
       R$ 237,68 — caro na vitrine e barato no caixa. */
    discountForQty(q) {
      let disc = 0;
      this.tiers.forEach((t) => {
        const tq = parseInt(t.dataset.tierQty, 10) || 0;
        const td = parseInt(t.dataset.tierDiscount, 10) || 0;
        if (tq <= q && td > disc) disc = td;
      });
      return disc;
    }

    /* Desconto por unidade, truncado — mesma conta do Shopify para desconto
       automatico por quantidade. Ver o comentario no Liquid dos tiers. */
    unitPrice(disc) {
      return this.base - Math.floor((this.base * disc) / 100);
    }

    totalPrice() {
      return this.unitPrice(this.discountForQty(this.qty)) * this.qty;
    }

    setQty(q) {
      if (Number.isNaN(q)) return;
      this.qty = Math.max(1, Math.min(this.maxQty, q));
      this.render();
    }

    render() {
      if (this.qtyDisplay) this.qtyDisplay.textContent = this.qty;
      if (this.quantityInput) this.quantityInput.value = this.qty;

      const economize = this.dataset.economize || 'economize';
      this.tiers.forEach((t) => {
        const tQty = parseInt(t.dataset.tierQty, 10);
        const tDisc = parseInt(t.dataset.tierDiscount, 10) || 0;
        const price = this.unitPrice(tDisc) * tQty;
        const save = this.base * tQty - price;
        const priceEl = t.querySelector('[data-tier-price]');
        const saveEl = t.querySelector('[data-tier-save]');
        if (priceEl) priceEl.textContent = this.money(price);
        if (saveEl) saveEl.innerHTML = save > 0 ? economize + ' ' + this.money(save) : '&nbsp;';

        const active = tQty === this.qty;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      // Os nos do CTA sao recriados pelo global.js durante o "adicionando",
      // entao sao consultados a cada render em vez de ficarem em cache.
      const ctaPrice = this.querySelector('[data-cta-price]');
      if (ctaPrice) ctaPrice.textContent = this.money(this.totalPrice());

      this.dispatchEvent(
        new CustomEvent('subscription:change', {
          bubbles: true,
          detail: { qty: this.qty, total: this.totalPrice() },
        })
      );
    }
  }

  if (!customElements.get('subscription-card')) {
    customElements.define('subscription-card', BuddyLabSubscriptionCard);
  }
  } catch(e) { console.error(e); }
})();

})();
